import angular from 'angular';
import 'angular-progress-button-styles/dist/angular-progress-button-styles';

export default angular.module('cms.panels.buttons-demo', ['angular-progress-button-styles'])
    .component('buttonsDemo', {
        template: require('./template.html'),
        controller: function ButtonDemoCtrl($scope, $timeout) {
            /** @ngInject */

            $scope.progressFunction = function() {
                return $timeout(function() {}, 3000);
            };
        }
    }).name;


// WEBPACK FOOTER //
// ./src/cmsPages/Dashboard/buttonsDemo/buttonsDemo.js